"use strict";
/**
 * Naming the months behind a trailing average (BEN-141 1d/B2, INS-007).
 *
 * `months_analyzed` counts COMPLETE months and is 0 whenever the divisor fell back
 * to a partial month, which is exactly when a sentence like "Last 0 months" would
 * be least true. Both helpers return null when there is no honest window to name,
 * so the caller omits the phrase instead of printing a zero. Shared so web and
 * mobile say the same thing about the same number.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MONTHS_USED_FLOOR = void 0;
exports.analyzedWindowLabel = analyzedWindowLabel;
exports.completeMonthsPhrase = completeMonthsPhrase;
exports.basisState = basisState;
/** "Last N months", or null when the window cannot be named. */
function analyzedWindowLabel(monthsAnalyzed) {
    if (!monthsAnalyzed || monthsAnalyzed < 1)
        return null;
    return monthsAnalyzed === 1 ? "Last month" : `Last ${monthsAnalyzed} months`;
}
/** "N complete months", mid-sentence, or null when the window cannot be named. */
function completeMonthsPhrase(monthsAnalyzed) {
    if (!monthsAnalyzed || monthsAnalyzed < 1)
        return null;
    return monthsAnalyzed === 1
        ? "1 complete month"
        : `${monthsAnalyzed} complete months`;
}
/**
 * Complete months required before a monthly average is shown as a number.
 * Mirrors the backend's MIN_COMPARISON_MONTHS (3), so "not enough history" means
 * one thing on every surface and both clients (INS-016).
 */
exports.MONTHS_USED_FLOOR = 3;
/**
 * Classify a figure by the basis it rests on.
 * - `insufficient`: fewer than MONTHS_USED_FLOOR complete months (at least one):
 *   show "Insufficient data" instead of the number.
 * - `partial-month`: zero complete months; the number carries the partial caveat.
 * - `ok`: enough history; show the number plainly.
 */
function basisState(monthsUsed) {
    if (monthsUsed === null || monthsUsed === undefined)
        return "insufficient";
    if (monthsUsed === 0)
        return "partial-month";
    return monthsUsed < exports.MONTHS_USED_FLOOR ? "insufficient" : "ok";
}
//# sourceMappingURL=dataWindow.js.map